// The page frame of partials/new-base.html (topbar, sidebar, back-to-top).
// Replaces what Velzon's app.js did for the vertical layout: the rest of it
// (two-column and horizontal layouts, customizer, language JSON, cart demo,
// counters, full screen, Waves/feather) had no markup left to act on.

const MOBILE_MAX = 767; // below 768 px the sidebar is off screen until the hamburger opens it

// Sidebar: mark the link of the current page active and open its group.
const activateCurrentLink = (nav) => {
  const path = location.pathname;
  const link = nav.querySelector(`[href="${CSS.escape(path)}"]`);
  if (!link) return;
  link.classList.add("active");
  const group = link.closest(".collapse.menu-dropdown");
  if (!group) return;
  group.classList.add("show");
  const toggle = group.parentElement.children[0];
  toggle.classList.add("active");
  toggle.setAttribute("aria-expanded", "true");
};

// Sidebar: opening a group closes the other groups at the same level, closing
// a group closes the groups inside it.
const accordionGroups = (nav) => {
  nav.querySelectorAll(".collapse").forEach((collapse) => {
    window.ui.collapse.get(collapse);
    collapse.addEventListener("ui:collapse:show", (event) => {
      event.stopPropagation();
      const level = collapse.parentElement.closest(".collapse") || nav;
      level.querySelectorAll(".collapse.show").forEach((other) => {
        if (other !== collapse && !other.contains(collapse)) window.ui.collapse.hide(other);
      });
    });
    collapse.addEventListener("ui:collapse:hide", (event) => {
      event.stopPropagation();
      collapse.querySelectorAll(".collapse.show").forEach((inner) => window.ui.collapse.hide(inner));
    });
  });
};

// Mobile menu: the hamburger slides the sidebar in over .vertical-overlay.
const mobileMenu = () => {
  const hamburger = document.getElementById("topnav-hamburger-icon");
  if (hamburger) {
    hamburger.addEventListener("click", () => {
      if (document.documentElement.clientWidth <= MOBILE_MAX) {
        document.body.classList.toggle("vertical-sidebar-enable");
      }
    });
  }
  document.querySelectorAll(".vertical-overlay").forEach((overlay) => {
    overlay.addEventListener("click", () => document.body.classList.remove("vertical-sidebar-enable"));
  });
  window.addEventListener("resize", () => {
    if (document.documentElement.clientWidth > MOBILE_MAX) {
      document.body.classList.remove("vertical-sidebar-enable");
    }
  });
};

// Topbar shadow and the back-to-top button follow the scroll position once the
// page scrolls (until then the button shows, as it always has).
const scrollState = () => {
  const topbar = document.getElementById("page-topbar");
  const backToTop = document.getElementById("back-to-top");
  const update = () => {
    const top = document.documentElement.scrollTop || document.body.scrollTop;
    if (topbar) topbar.classList.toggle("topbar-shadow", top >= 50);
    if (backToTop) backToTop.style.display = top > 100 ? "block" : "none";
  };
  document.addEventListener("scroll", update);
};

// <button id="back-to-top" onclick="topFunction()"> in new-customizer.html.
window.topFunction = () => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
};

const init = () => {
  const nav = document.getElementById("navbar-nav");
  if (nav) {
    activateCurrentLink(nav);
    accordionGroups(nav);
  }
  mobileMenu();
  scrollState();

  // Tab links inside a dropdown menu switch the tab without closing the menu.
  document.querySelectorAll('.dropdown-menu a[data-ui-toggle="tab"]').forEach((link) => {
    link.addEventListener("click", (event) => {
      event.stopPropagation();
      window.ui.tab.show(event.target);
    });
  });

  // After every page script, so markup they add is included.
  window.ui.tooltip.init();
  window.ui.popover.init();
};

try {
  document.addEventListener("DOMContentLoaded", init);
} catch (error) {
  console.error("appShell", error);
}
